import CustomModal from "../CustomModal";
import ReportPDFEmailForm from "./ReportPDFEmailForm";

const ReportEmailPdfModal = ({header="Email To",show=false,size="lg",onHide}) => {
    return(
        <CustomModal 
        header={header}
        show={show}
        size={size}
        onHide={onHide}
        closeButtonText="Cancel"
        submitButtonText="Okay"
        >

          <ReportPDFEmailForm />
        
        </CustomModal>
    )
}
export default ReportEmailPdfModal;